
































export default {
    name: 'GooglePlacesInput',

    setup(props) {
        const inputRef = ref(props.refName);
        const address = ref({});

        return { inputRef, address };
    },

    props: {
        label: {
            required: true,
            type: String,
        },
        value: {
            default: null,
            required: false,
            type: [String, Object],
        },
        placeholder: {
            required: false,
            type: String,
        },
        error: {
            default: '',
            required: false,
            type: String,
        },
        disabled: {
            required: false,
            type: Boolean,
        },
        refName: {
            required: true,
            type: String,
        },
        addressType: {
            default: null,
            required: false,
            type: String,
        },
        fullAddress: {
            default: true,
            required: false,
            type: Boolean,
        },
        switcher: {
            default: false,
            required: false,
            type: Boolean,
        },
    },

    watch: {
        fullAddress: {
            handler() {
                this.initAutocomplete();
            },
            immediate: true,
        },
    },

    methods: {
        /**
         * Reset the address when the input is updated and check whether the
         * input contains a value. If it doesn't, emit a NULL value.
         * Otherwise, set the address line1 to input value.
         *
         * @note The address object's values will only be set once
         *        the user selects a location from the dropdown.
         *
         * @param {InputEvent} event
         */
        handleInput(event: InputEvent) {
            this.address = {};

            const inputValue = event.target.value;

            if (!inputValue.length) {
                this.$emit('input', null);
                return;
            }

            this.address.line1 = inputValue;
            this.$emit('input', this.address);
        },

        async initAutocomplete() {
            const { Autocomplete } = await google.maps.importLibrary('places');

            const options = {
                types: this.fullAddress ? ['address'] : ['(regions)'],
                componentRestrictions: { country: ['ZA', 'GB', 'NA'] },
                fields: ['formatted_address', 'address_component', 'geometry'],
            };

            this.inputRef = new Autocomplete(this.$refs[this.refName], options);

            this.inputRef.addListener('place_changed', () => {
                let place = this.inputRef.getPlace();

                if (this.addressType) {
                    this.address.address_type = this.addressType;
                }

                this.address.line1 = place.formatted_address;
                this.address.postal_code = null;
                this.address.lat = place.geometry.location.lat().toString();
                this.address.long = place.geometry.location.lng().toString();

                place.address_components.forEach((item) => {
                    let types = item.types;
                    const findType = (type) => {
                        if (types.includes(type)) {
                            return types;
                        }
                    };
                    switch (types) {
                        case findType('administrative_area_level_2'): {
                            this.address.city = item.long_name;
                            break;
                        }
                        case findType('administrative_area_level_1'): {
                            this.address.province = item.long_name;
                            break;
                        }
                        case findType('postal_code'): {
                            this.address.postal_code = item.long_name;
                            break;
                        }
                        case findType('country'): {
                            this.address.country = item.short_name;
                            break;
                        }
                        default: {
                            break;
                        }
                    }
                });

                this.$emit('input', this.address);
            });
        },
    },
};
